export interface AdjacentGroup<TItem, TKey> {
	key: TKey;
	items: ReadonlyArray<TItem>;
}

export function groupAdjacent<TItem, TKey>(
	items: ReadonlyArray<TItem>,
	getKey: (item: TItem) => TKey,
	isGroupable?: (key: TKey) => boolean,
): ReadonlyArray<AdjacentGroup<TItem, TKey>> {
	const groups: Array<{ key: TKey; items: Array<TItem> }> = [];

	for (const item of items) {
		const key = getKey(item);
		const last = groups.at(-1);

		if (last != null && last.key === key && (isGroupable == null || isGroupable(key))) {
			last.items.push(item);
		} else {
			groups.push({ key, items: [item] });
		}
	}

	return groups;
}
